/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Umair's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Umair Arshad Portfolio",
    type: "website",
    url: "http://devumairarshad.com/",
  },
};

//Home Page
const greeting = {
  title: "Umair Arshad",
  logo_name: "Umair Arshad",
  nickname: null,
  subTitle:
    "Senior Full-Stack Software Engineer with 6+ years of experience building scalable web applications, microservices, and e-commerce solutions for US-based companies and startups.",
  resumeLink:
    "https://drive.google.com/file/d/1r3PQrfsmctk_p7Vn-tHDl0RPjsq6dDlA/view?usp=sharing",
  portfolio_repository: "https://github.com/UmairArshadShk/myPortfolio",
  githubProfile: "https://github.com/UmairArshadShk",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/UmairArshadShk",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/UmairArshadShk",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/dev-umair-arshad/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link: "https://youtube.com/c/DevSense19",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link: "mailto:devumair.arshad@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "X-Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
  //   backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Deeplearning",
    //       imageSrc: "deeplearning_ai_logo.png",
    //     },
    //   ],
    // },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux",
        "⚡ Worked on microservice architecture",
        "⚡ Develop APIs and worked on both Backend and Front-end",
        "⚡ Creating application backend in Node, Express & Flask",
      ],
      softwareSkills: [
        {
          skillName: "Ruby on Rails",
          imageSrc: "rails.png",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Java Spring Boot",
          imageSrc: "java_spring_boot.png",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJs",
          imageSrc: "nextjs.png",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Shopify",
          fontAwesomeClassname: "simple-icons:shopify",
          style: {
            color: "#7AB55C",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
      ],
    },
    {
      title: "Shopify & E-Commerce",
      fileName: "DesignImg",
      skills: [
        "⚡ ~2 years of experience building and customizing Shopify stores",
        "⚡ Custom theme development with Liquid, HTML, CSS, and JavaScript",
        "⚡ Shopify REST & GraphQL API integrations for products, orders, and checkout",
        "⚡ Third-party app integrations, subscription flows, and storefront performance optimization",
      ],
      softwareSkills: [
        {
          skillName: "Shopify",
          fontAwesomeClassname: "simple-icons:shopify",
          style: {
            color: "#7AB55C",
          },
        },
        {
          skillName: "Liquid",
          fontAwesomeClassname: "simple-icons:shopify",
          style: {
            color: "#95BF47",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#E10098",
          },
        },
        {
          skillName: "Tailwind CSS",
          fontAwesomeClassname: "simple-icons:tailwindcss",
          style: {
            color: "#06B6D4",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "Heroku",
          imageSrc: "heroku.png",
          style: {},
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "My SQL",
          imageSrc: "my_sql.png",
          style: {},
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Redis",
          imageSrc: "redis.png",
          style: {},
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "Developing and Managing Microservices",
      fileName: "DesignImg",
      skills: [
        "⚡ Building microservices using RoR, Node & Java Spring Boot",
        "⚡ Experience in building and managing microservices",
        "⚡ Creating and managing APIs",
        "⚡ Implementing Kafka and SQS for event driven architecture",
        "⚡ Monitoring and managing microservices using Datadog and Papertrail",
      ],
      softwareSkills: [
        {
          skillName: "Kafka",
          imageSrc: "kafka.png",
          style: {},
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Papertrail",
          imageSrc: "papertrail.png",
          style: {
            backgroundColor: "#00b8ff",
          },
        },
        {
          skillName: "DataDog",
          imageSrc: "datadog.png",
          style: {},
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    //   {
    //     siteName: "LeetCode",
    //     iconifyClassname: "simple-icons:leetcode",
    //     style: {
    //       color: "#F79F1B",
    //     },
    //     profileLink: "https://leetcode.com/layman_brother/",
    //   }
  ],
};

const degrees = {
  degrees: [
    {
      title: "Punjab University College of Information Technology",
      subtitle: "BS in Software Engineering",
      logo_path: "pucit.png",
      alt_name: "PUCIT",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, OOP etc.",
        "⚡ Graduated with Distinction — CGPA 3.81 out of 4.0.",
        "⚡ Awarded Merit cum Means Scholarship given to top 5% of students in college.",
        "⚡ Served as a Teaching Assistant due to consistently strong academic performance.",
      ],
      website_link: "https://pucit.edu.pk/",
    },
    {
      title: "Superior Group of Colleges",
      subtitle: "Intermediate in Computer Science",
      logo_path: "college.png",
      alt_name: "Superior College",
      duration: "2014 - 2016",
      descriptions: [
        "⚡ I studied foundational subjects in computer science, including Programming, Database Management, and Mathematics.",
        "⚡ I participated in various technical workshops and extracurricular activities, enhancing my understanding of the field.",
        "⚡ My experience at Superior College laid a strong foundation for my future studies in software engineering.",
      ],
      website_link: "https://www.superiorcolleges.edu.pk/",
    },
  ],
};

const certifications = {
  certifications: [
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "Senior Full-Stack Software Engineer with 6+ years of experience designing and scaling production-grade applications for US-based companies. Specialized in Ruby on Rails, Node.js, React, Java Spring Boot, microservices, AI/LLM integrations, and Shopify e-commerce development.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Software Engineer",
          company: "CodingCops",
          company_url: "https://codingcops.com/",
          logo_path: "codingcops.png",
          logo_style: {
            borderRadius: "15px",
            padding: "12px",
          },
          duration: "March 2023 - Present",
          location: "Lahore, Punjab, Pakistan",
          description:
            "Led a 10-engineer cross-functional team across three concurrent product lines for US clients including Revinate, establishing engineering standards and sprint workflows that accelerated releases from bi-weekly to weekly and reduced production defects by ~30%. Architected event-driven microservices on AWS using Ruby on Rails, Node.js, and Java Spring Boot with Kafka and Amazon SQS. Delivered AI-powered features using OpenAI APIs and Google Dialogflow, including conversational customer-service tools and an LLM-driven analytics dashboard. Full-stack development on Revinate products — Ivy, Marketing, and Reservation Sales — using React, Next.js, and scalable REST APIs.",
          color: "#9b1578",
        },
        {
          title: "Software Engineer",
          company: "CodingCops",
          company_url: "https://codingcops.com/",
          logo_path: "codingcops.png",
          logo_style: {
            borderRadius: "15px",
            padding: "12px",
          },
          duration: "July 2020 - February 2023",
          location: "Lahore, Punjab, Pakistan",
          description:
            "Developed full-stack features for US hospitality clients including GoMoment and Revinate on the Ivy guest messaging platform. Built backend services in Ruby on Rails, frontend in React, and integrations with PMS systems, Google Dialogflow chatbots, Twilio, and Bandwidth for SMS. Designed scalable REST APIs and microservices with PostgreSQL, Redis, and MongoDB. Implemented monitoring and observability using Datadog and Papertrail across production services.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Shopify & E-Commerce",
      experiences: [
        {
          title: "Shopify Developer",
          company: "Freelance",
          company_url: "https://lwya.com/",
          logo_path: "shopify-logo.png",
          logo_style: {
            borderRadius: "15px",
            padding: "12px",
          },
          duration: "~2 Years",
          location: "Remote",
          description:
            "Built and customized Shopify stores with ~2 years of hands-on experience in e-commerce development. Specialized in custom theme development using Liquid, HTML, CSS, and JavaScript; Shopify REST and GraphQL API integrations for products, orders, inventory, and checkout; third-party app integrations; and storefront performance optimization. Delivered production stores including lwya.com and plantapothcary.com with bespoke UI, subscription workflows, and conversion-focused product pages.",
          color: "#7AB55C",
        },
      ],
    },
    {
      title: "Side Projects",
      experiences: [
        {
          title: "Software Engineer",
          company: "Dock",
          company_url: "https://dock.bot/",
          logo_path: "dock.png",
          logo_style: {
            background: "black",
            borderRadius: "15px",
            padding: "16px",
          },
          description:
            "Built chatbot platform features including subscriptions, LPR, action logging, and payment gateway integrations with Stripe and Authorize.net.",
          color: "#4285F4",
        },
        {
          title: "Freelancer",
          company: "Safety Matrix",
          company_url: "https://safetymatrix.com.pk/",
          logo_path: "safetymatrix.png",
          logo_style: {
            borderRadius: "15px",
          },
          description:
            "Developed the complete company website using React and Redux. Deployed on Heroku and Firebase.",
          color: "#D83B01",
        },
        {
          title: "Freelancer",
          company: "GnG",
          company_url: "https://gng.com.pk/",
          logo_path: "gng.png",
          description:
            "Developed the complete company website using React and Redux. Deployed on Heroku.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A selection of production applications and e-commerce stores I've built — from Revinate's hospitality platforms to custom Shopify storefronts — spanning full-stack development, microservices, and API integrations.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Featured Work",
  description:
    "Highlight projects across hospitality SaaS and Shopify e-commerce development.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile-img.jpeg",
    profile_image_style: {
      borderRadius: "50%",
    },
    description:
      "I’m always open to discussing interesting projects, technical challenges, and opportunities to build impactful software. Whether you need help with a full-stack application, system architecture, or scaling an existing product, feel free to reach out.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  addressSection: {
    title: "Address",
    subtitle: "Lahore, Punjab, Pakistan",
    locality: "San Jose",
    country: "Pakistan",
    region: "Punjab",
    postalCode: "54000",
    streetAddress: "Lahore",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
